// src/components/CompanyProfileHeader.jsx
import React from "react";
import ProfileHeader from "./TabsHeader";

export default function CompanyProfileHeader({
  company,
  tab,
  onTabChange,
  counts = {},
  newAction,
  onNewActionChange,
  dateText,
  sx = {},

  title = "Company Profile",
  tabs,
  metaLabel = "Team Member",
  metaValue,
  onMetaValueClick,
  actionLabel = "",
  actionPlaceholder = "New",
  actionShowPlaceholderOption = true,
  actionOptions,
  actionSx,
  showAction = true,
  actionDisabled = false,
  actionFeedback,
  onActionFeedbackClose,
  summaryRow = null,
}) {
  const defaultTabs = [
    { value: "details", label: "Details" },
    { value: "leads", label: "Leads", countKey: "leads" },
    { value: "contacts", label: "Contacts", countKey: "contacts" },
    { value: "jobs", label: "Jobs", countKey: "jobs" },
    { value: "activities", label: "Activities", countKey: "activities" },
  ];

  const defaultActionOptions = [
    { value: "new_lead", label: "New Lead" },
    { value: "new_contact", label: "New Contact" },
    { value: "new_job", label: "New Job" },
    { value: "new_activity", label: "New Activity" },
  ];

  return (
    <ProfileHeader
      title={title}
      tab={tab}
      onTabChange={onTabChange}
      tabs={tabs?.length ? tabs : defaultTabs}
      counts={counts}
      summaryRow={summaryRow}
      metaLabel={metaLabel}
      metaValue={metaValue ?? (company?.owner || "Paul Stark")}
      onMetaValueClick={onMetaValueClick}
      dateText={dateText}
      showAction={showAction}
      actionLabel={actionLabel}
      actionValue={newAction}
      onActionChange={onNewActionChange}
      actionPlaceholder={actionPlaceholder}
      actionShowPlaceholderOption={actionShowPlaceholderOption}
      actionOptions={actionOptions?.length ? actionOptions : defaultActionOptions}
      actionSx={actionSx}
      actionDisabled={actionDisabled}
      actionFeedback={actionFeedback}
      onActionFeedbackClose={onActionFeedbackClose}
    
      sx={sx}
    />
  );
}
